import React from 'react';
import { ListOrderRender } from 'types/OrderList';
import { getOrderDateAndTime } from 'utils';
import { TableRow, TableCellWrapper, TableCell } from './ItemListOrder.style';

const ItemListOrder = ({
  id,
  dateAndTime,
  orderIds,
  attributes,
  soldAt,
  netRevenue,
  isOpenPanelRight,
  passId
}: ListOrderRender) => {
  const { date, time } = getOrderDateAndTime(dateAndTime);

  const onItemDetail = (id: number) => {
    isOpenPanelRight(true);
    passId(id);
  };

  return (
    <TableRow onClick={() => onItemDetail(id)}>
      <TableCellWrapper>
        <div className="timeHours">{time}</div>
        <div className="day">{date}</div>
      </TableCellWrapper>
      <TableCell>
        <div className="orderIds">{orderIds}</div>
      </TableCell>
      <TableCell>
        <div className="attributes">{attributes}</div>
      </TableCell>
      <TableCell>{soldAt}</TableCell>
      <TableCell>{netRevenue}</TableCell>
    </TableRow>
  );
};

export default ItemListOrder;
